// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mr29","content":"styles_content__1jrWA"};